export const ONE_MIN_MS = 60 * 1000;
export const ONE_HOUR_MS = 60 * ONE_MIN_MS;

function padTime(num: number) {
	return String(num).padStart(2, "0");
}

export function formatDuration(
	durationMs: number,
	{
		allowSeconds = true,
		allowHours = true,
		alwaysShowHours = true,
		allowDays = false,
		alwaysShowDays = false,
	}: {
		allowSeconds?: boolean;
		allowHours?: boolean;
		alwaysShowHours?: boolean;
		allowDays?: boolean;
		alwaysShowDays?: boolean;
	} = {},
) {
	const totalSeconds = Math.round(durationMs / 1000);
	const totalMinutes = allowSeconds ? Math.floor(totalSeconds / 60) : Math.round(totalSeconds / 60);
	const totalHours = Math.floor(totalMinutes / 60);
	const totalDays = Math.floor(totalHours / 24);

	const seconds = totalSeconds % 60;
	const minutes = allowHours ? totalMinutes % 60 : totalMinutes;
	const hours = allowDays ? totalHours % 24 : totalHours;
	const days = totalDays;

	const showSeconds = allowSeconds;
	const showDays = allowDays && allowDays && (days > 0 || alwaysShowDays);
	const showHours = allowHours && (hours > 0 || alwaysShowHours || showDays);

	const times: string[] = [];
	if (showSeconds) {
		times.push(padTime(seconds));
	}
	times.push(padTime(minutes));
	if (showHours) {
		times.push(padTime(hours));
	}
	if (showDays) {
		times.push(String(days));
	}
	return times.reverse().join(":");
}

/**
 * Given a time in ms, returns a screen reader friendly spoken string.
 * @param timeStr
 * @returns
 */
export function getDurationAriaLabelFromMs(ms: number): string {
	const totalSeconds = Math.floor(ms / 1000);

	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;

	const segments = [];
	if (hours) segments.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
	if (minutes || (!hours && !seconds)) segments.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
	if (seconds || (!hours && !minutes)) segments.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);

	return segments.join(", ");
}

export function changeTimeOnly(oldDateTime: Date, hours: number, minutes: number) {
	const newDateTime = new Date(oldDateTime.getTime());
	newDateTime.setHours(hours);
	newDateTime.setMinutes(minutes);
	return newDateTime;
}

export function stripSeconds(date: Date) {
	const newDateTime = new Date(date.getTime());
	newDateTime.setSeconds(0);
	newDateTime.setMilliseconds(0);
	return newDateTime;
}

export function isBetweenTimes(target: Date, start: Date, end: Date) {
	return target.getTime() >= start.getTime() && target.getTime() <= end.getTime();
}
